import * as React from "react";
import ModalDialog from "../../components/ModalDialog";
import { Button, Grid, Typography } from "@mui/material";
import Glossary from "../../components/HelpContent/Glossary";
import { KeyValue, Query } from "../../interfaces";
import useGetTableCheckboxState from "../../hooks/useGetTableCheckboxState";

interface Props {
  title: string;
  appState: Query;
  text: string;
  appDisplay: string;
  onValuesUpdate: (values: string) => void;
  selectedVariables: string[];
  link?: React.ReactElement;
  mandatorySelections?: boolean;
  mandatoryVariables?: string;
  additionalFilters?: string;
}
export default function LookupVariable({
  title,
  appState,
  text,
  appDisplay,
  link,
  mandatorySelections,
  mandatoryVariables,
  onValuesUpdate,
  selectedVariables,
  additionalFilters,
}: Props) {
  const [openLookupModal, setOpenLookupModal] = React.useState(false);
  const [clearCheckboxes, setClearCheckboxes] = React.useState(false);
  const [visibleTableCheckboxes, setVisibleCheckboxes] = React.useState<
    string[]
  >([]);
  const tableCheckBoxState: KeyValue = useGetTableCheckboxState(
    appState,
    clearCheckboxes,
    setClearCheckboxes,
    undefined,
    visibleTableCheckboxes,
  );
  const checkedTableValues = [
    ...Object.keys(tableCheckBoxState.body.allCheckboxes).filter(
      (val: string) => tableCheckBoxState.body.allCheckboxes[val],
    ),
  ];
  const filteredCheckTableValues = checkedTableValues.filter(
    (value: string, index: number) =>
      value !== "" && checkedTableValues.indexOf(value) === index,
  );

  const lookupVariableModal = (
    <ModalDialog
      title={title}
      display={openLookupModal}
      setDisplay={setOpenLookupModal}
      maxWidth="lg"
      noCloseXIcon
      onExited={() => setClearCheckboxes(true)}
      onAction={() => {
        onValuesUpdate(
          [...selectedVariables, ...filteredCheckTableValues].join(`\n`),
        );
        setOpenLookupModal(false);
      }}
    >
      <>
        <Typography variant="body2" color="primary">
          {text}
          {link}
        </Typography>
        <Grid container spacing={2}>
          <Grid item md={10} xs={12}>
            <Glossary
              appDisplay={appDisplay}
              tableCheckBoxes={tableCheckBoxState}
              setVisibleCheckboxes={setVisibleCheckboxes}
              additionalFilters={additionalFilters}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            {mandatorySelections && (
              <>
                <Typography variant="h3">Mandatory Variables</Typography>
                <Typography id="list-var" style={{ marginBottom: "1rem" }}>
                  {mandatoryVariables}
                </Typography>
              </>
            )}

            <Typography variant="h3">Selected Variables</Typography>
            <Typography id="list-var" style={{ marginBottom: "1rem" }}>
              {filteredCheckTableValues.join(", ")}
            </Typography>
          </Grid>
        </Grid>
      </>
    </ModalDialog>
  );
  return (
    <>
      <Button
        id="lookUpVariables"
        fullWidth
        variant="contained"
        color="secondary"
        onClick={() => setOpenLookupModal(true)}
      >
        Look Up Variables
      </Button>

      {lookupVariableModal}
    </>
  );
}
